import React from 'react'
import SiteHeader from '../components/SiteHeader'
import NotificationBanner from '../components/NotificationBanner'
import { usePageViewTracking } from '../core'
import ArticleHeader from '../components/ArticleHeader'
import Container from '../components/Container'
import { SEO } from '../components/SEO'
import Icon from 'src/components/Icon'

const EmailComplaint = () => {
  usePageViewTracking()
  return (
    <>
      <SiteHeader search sticky />
      <NotificationBanner />
      <ArticleHeader currentCategory="Complaint not resolved?" currentPage="" />

      <main className="px-0 pt-6 pb-10 lg:pt-12">
        <Container>
          <section className="flex flex-wrap w-full mb-0 sm:flex-no-wrap sm:mb-6 lg:w-4/5">
            <section className="w-full">
              <div className="mb-2">
                <p className="mb-4 text-2xl font-semibold">
                  The quickest way for you to get a query or complaint resolved
                  is to use our FAQs or contact forms.
                </p>
              </div>
              <div className="flex flex-wrap items-start mb-4 text-left">
                <a
                  className="inline-flex items-center self-center px-8 py-3 mb-2 mr-2 text-white rounded-lg cursor-pointer mb- 2text-center sm:px-6 bg-secondary hover:bg-secondary-dark"
                  href="/help"
                >
                  {' '}
                  <span className="font-semibold text-white whitespace-no-wrap">
                    Search our FAQs
                  </span>
                  <div className="inline-flex items-center w-6 h-6">
                    <Icon
                      icon="forwardArrow"
                      className="w-4 h-4 ml-3 fill-current"
                    />
                  </div>
                </a>
                <a
                  className="inline-flex items-center self-center px-8 py-3 mb-2 mr-2 text-center text-white rounded-lg cursor-pointer sm:px-6 bg-secondary hover:bg-secondary-dark"
                  href="/help/call-us/"
                >
                  <Icon icon="phone" className="w-6 h-6 mr-3 fill-current" />
                  <span className="font-semibold text-white whitespace-no-wrap">
                    Call us
                  </span>
                </a>
                <a
                  className="inline-flex items-center self-center px-8 py-3 mb-2 text-center text-white rounded-lg cursor-pointer sm:px-6 bg-secondary hover:bg-secondary-dark"
                  href="/help/form/contact-us"
                >
                  <Icon
                    icon="mailoutline"
                    className="w-6 h-6 mr-3 fill-current"
                  />
                  <span className="font-semibold text-white whitespace-no-wrap">
                    Email us
                  </span>
                </a>
              </div>
              <div className="mb-2">
                <p className="text-lg font-medium">
                  If you have tried that, and we haven&apos;t been able to
                  resolve your query, you can contact the relevant member of our
                  leadership team. If your query relates to:
                </p>
                <ul className="w-full mx-4 my-8 space-y-4 text-lg list-disc list-outside">
                  {/* <li className="flex flex-wrap items-center">
                    <span className="w-full pr-1 md:w-auto">
                      Our More Card loyalty scheme, please contact
                    </span>
                    <span className="flex flex-wrap">
                      <a
                        href="mailto:darren@morrisons.co.uk?subject=Morrisons Help Hub Enquiry"
                        className="mr-3 underline"
                      >
                        Darren Blackhurst
                      </a>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=darren@morrisons.co.uk&su=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Darren Blackhurst with Yahoo"
                      >
                        <Icon icon="emailGmail" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="https://outlook.live.com/owa/?path=/mail/action/compose&to=darren@morrisons.co.uk&subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Darren Blackhurst with Yahoo"
                      >
                        <Icon icon="emailOutlook" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="http://compose.mail.yahoo.com/?to=darren@morrisons.co.uk&subj=Your%20Subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Darren Blackhurst with Yahoo"
                      >
                        <Icon icon="emailYahoo" className="w-5 h-5" />
                      </a>
                    </span>
                  </li> */}
                  <li className="flex flex-wrap items-center">
                    <span className="w-full pr-1 md:w-auto">
                      Service and standards in our supermarkets, please contact
                    </span>
                    <span className="flex flex-wrap">
                      <a
                        href="mailto:martin@morrisons.co.uk?subject=Morrisons Help Hub Enquiry"
                        className="mr-3 underline"
                      >
                        Martin Dawson
                      </a>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=martin@morrisons.co.uk&su=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Martin Dawson with Gmail"
                      >
                        <Icon icon="emailGmail" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="https://outlook.live.com/owa/?path=/mail/action/compose&to=martin@morrisons.co.uk&subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Martin Dawson with Outlook"
                      >
                        <Icon icon="emailOutlook" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="http://compose.mail.yahoo.com/?to=martin@morrisons.co.uk&subj=Your%20Subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Martin Dawson with Yahoo"
                      >
                        <Icon icon="emailYahoo" className="w-5 h-5" />
                      </a>
                    </span>
                  </li>
                  <li className="flex flex-wrap items-center">
                    <span className="w-full pr-1 md:w-auto">
                      Our Online Groceries service, please contact
                    </span>
                    <span className="flex flex-wrap">
                      <a
                        href="mailto:charlotte@morrisons.co.uk?subject=Morrisons Help Hub Enquiry"
                        className="mr-3 underline"
                      >
                        Charlotte Exell
                      </a>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=charlotte@morrisons.co.uk&su=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Charlotte Exell with Gmail"
                      >
                        <Icon icon="emailGmail" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="https://outlook.live.com/owa/?path=/mail/action/compose&to=charlotte@morrisons.co.uk&subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Charlotte Exell with Outlook"
                      >
                        <Icon icon="emailOutlook" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="http://compose.mail.yahoo.com/?to=charlotte@morrisons.co.uk&subj=Your%20Subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Charlotte Exell with Yahoo"
                      >
                        <Icon icon="emailYahoo" className="w-5 h-5" />
                      </a>
                    </span>
                  </li>

                  <li className="flex flex-wrap items-center">
                    <span className="w-full pr-1 md:w-auto">
                      Our Morrisons Daily or McColl&apos;s convenience stores,
                      please contact
                    </span>
                    <span className="flex flex-wrap">
                      <a
                        href="mailto:matthew@morrisons.co.uk?subject=Morrisons Help Hub Enquiry"
                        className="mr-3 underline"
                      >
                        Matthew Heslop
                      </a>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=matthew@morrisons.co.uk&su=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Matthew Heslop with Gmail"
                      >
                        <Icon icon="emailGmail" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="https://outlook.live.com/owa/?path=/mail/action/compose&to=matthew@morrisons.co.uk&subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Matthew Heslop with Outlook"
                      >
                        <Icon icon="emailOutlook" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="http://compose.mail.yahoo.com/?to=matthew@morrisons.co.uk&subj=Your%20Subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email Matthew Heslop with Yahoo"
                      >
                        <Icon icon="emailYahoo" className="w-5 h-5" />
                      </a>
                    </span>
                  </li>
                  <li className="flex flex-wrap items-center">
                    <span className="w-full pr-1 md:w-auto">
                      Working with us as a new or existing supplier, including
                      getting involved with our new WIGIG programme,{' '}
                      <span className="whitespace-no-wrap">please contact</span>
                    </span>
                    <span className="flex flex-wrap">
                      <a
                        href="mailto:james.c.badger@morrisonsplc.co.uk?subject=Morrisons Help Hub Enquiry"
                        className="mr-3 underline"
                      >
                        James Badger
                      </a>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=james.c.badger@morrisonsplc.co.uk&su=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email James Badger with Gmail"
                      >
                        <Icon icon="emailGmail" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="https://outlook.live.com/owa/?path=/mail/action/compose&to=james.c.badger@morrisonsplc.co.uk&subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email James Badger with Outlook"
                      >
                        <Icon icon="emailOutlook" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="http://compose.mail.yahoo.com/?to=james.c.badger@morrisonsplc.co.uk&subj=Your%20Subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email James Badger with Yahoo"
                      >
                        <Icon icon="emailYahoo" className="w-5 h-5" />
                      </a>
                    </span>
                  </li>
                  <li className="flex flex-wrap items-center">
                    <span className="w-full pr-1 md:w-auto">
                      Our charity and community programme, please contact
                    </span>
                    <span className="flex flex-wrap">
                      <a
                        href="mailto:davidscott@morrisons.co.uk?subject=Morrisons Help Hub Enquiry"
                        className="mr-3 underline"
                      >
                        David Scott
                      </a>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=davidscott@morrisons.co.uk&su=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email David Scott with Gmail"
                      >
                        <Icon icon="emailGmail" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="https://outlook.live.com/owa/?path=/mail/action/compose&to=davidscott@morrisons.co.uk&subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email David Scott with Outlook"
                      >
                        <Icon icon="emailOutlook" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="http://compose.mail.yahoo.com/?to=davidscott@morrisons.co.uk&subj=Your%20Subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email David Scott with Yahoo"
                      >
                        <Icon icon="emailYahoo" className="w-5 h-5" />
                      </a>
                    </span>
                  </li>
                  <li className="flex flex-wrap items-center">
                    <span className="w-full pr-1 md:w-auto">
                      Joining our team, please contact our
                    </span>
                    <span className="flex flex-wrap">
                      <a
                        href="mailto:resourcing@morrisonsplc.co.uk?subject=Morrisons Help Hub Enquiry"
                        className="mr-3 underline"
                      >
                        Resourcing Team
                      </a>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=resourcing@morrisonsplc.co.uk&su=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email the Resourcing Team with Gmail"
                      >
                        <Icon icon="emailGmail" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="https://outlook.live.com/owa/?path=/mail/action/compose&to=resourcing@morrisonsplc.co.uk&subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email the Resourcing Team with Outlook"
                      >
                        <Icon icon="emailOutlook" className="w-5 h-5 mr-3" />
                      </a>
                      <a
                        href="http://compose.mail.yahoo.com/?to=resourcing@morrisonsplc.co.uk&subj=Your%20Subject=Morrisons%20Help%20Hub%20Enquiry"
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="Email the Resourcing Team with Yahoo"
                      >
                        <Icon icon="emailYahoo" className="w-5 h-5" />
                      </a>
                    </span>
                  </li>
                </ul>
              </div>
              <div className="flex flex-wrap items-center mb-6 text-lg text-left">
                <span className="w-full pr-1 md:w-auto">
                  Or, if your query relates to a different topic and we
                  haven&apos;t been able to resolve it through the options
                  provided above, please let our CEO, Rami, know by emailing
                </span>
                <span className="flex flex-wrap">
                  <a
                    className="mr-3 underline"
                    href="mailto:rami@morrisons.co.uk?subject=Morrisons Help Hub Enquiry"
                  >
                    rami@morrisons.co.uk
                  </a>
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=rami@morrisons.co.uk&su=Morrisons%20Help%20Hub%20Enquiry"
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="Email Rami with Gmail"
                  >
                    <Icon icon="emailGmail" className="w-5 h-5 mr-3" />
                  </a>
                  <a
                    href="https://outlook.live.com/owa/?path=/mail/action/compose&to=rami@morrisons.co.uk&subject=Morrisons%20Help%20Hub%20Enquiry"
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="Email Rami with Outlook"
                  >
                    <Icon icon="emailOutlook" className="w-5 h-5 mr-3" />
                  </a>
                  <a
                    href="http://compose.mail.yahoo.com/?to=rami@morrisons.co.uk&subj=Your%20Subject=Morrisons%20Help%20Hub%20Enquiry"
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="Email Rami with Yahoo"
                  >
                    <Icon icon="emailYahoo" className="w-5 h-5" />
                  </a>
                </span>
              </div>
            </section>
          </section>
        </Container>
      </main>
    </>
  )
}

export default EmailComplaint

export const Head = () => {
  return <SEO title="Complaint not resolved? - Morrisons Help Hub" />
}
